import { render, staticRenderFns } from "./AdiPaiCureDomiciliariPianoTerapeuticoComponent.vue?vue&type=template&id=03804ffb"
import script from "./AdiPaiCureDomiciliariPianoTerapeuticoComponent.vue?vue&type=script&lang=js"
export * from "./AdiPaiCureDomiciliariPianoTerapeuticoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports